import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CloseButton,
  ModalContent,
  Title,
  Description,
  ModalPopup,
  modalStyles
} from './styled';
import { Icon, IconColor } from '../Icon';
import CloseIcon from '../../public/static/images/item/close.svg';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import {
  ProfileBusinessTabsValueEnum,
  useProfileBusinessTabsState
} from '../../hooks/useProfileBusinessTabsState';
import type { CompanyNotification } from '../../graphql/graphql';

export interface WelcomeBannerProps
  extends Pick<
    CompanyNotification,
    'id' | 'title' | 'description' | 'imageUrl'
  > {
  isOpen?: boolean;
  hide: () => void;
}

export const WelcomeBanner: React.FC<WelcomeBannerProps> = ({
  id,
  title,
  description,
  isOpen,
  hide,
  imageUrl
}) => {
  const { t } = useTranslation();

  const { optionHandleClick } = useProfileBusinessTabsState();

  const handleOpenProfilePackages = () => {
    hide();
    optionHandleClick(ProfileBusinessTabsValueEnum.balance);
  };

  return (
    <Modal
      isOpen={!!isOpen}
      onClose={hide}
      modalId="replenishment-notification-modal"
      cypress="replenishment-notification-modal"
      modalStyles={modalStyles}
      title=""
      closeButtonAlign="right"
      setMediaStyles={false}
    >
      <ModalPopup $imageUrl={imageUrl}>
        <CloseButton
          onClick={hide}
          data-stat="replenishment-notification-close"
        >
          <i onClick={hide} onKeyPress={hide} role="button" tabIndex={-1}>
            <Icon
              indent={false}
              IconComponent={CloseIcon}
              width={15}
              height={15}
              color={IconColor.white}
            />
          </i>
        </CloseButton>
        <ModalContent>
          <Title>{title}</Title>
          <Description>{description}</Description>
          <Button
            onClick={handleOpenProfilePackages}
            cypress="replenishment-notification-button"
            stat="replenishment-notification-button"
          >
            {t('common.details')}
          </Button>
        </ModalContent>
      </ModalPopup>
    </Modal>
  );
};
